/**
 * Cliente View Dialog Component
 */

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { Cliente } from "@/types/cliente";
import { format } from "date-fns";

interface ClienteViewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  cliente: Cliente | null;
}

export function ClienteViewDialog({
  open,
  onOpenChange,
  cliente,
}: ClienteViewDialogProps) {
  if (!cliente) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Detalhes do Cliente</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <h3 className="font-semibold text-lg">{cliente.nome}</h3>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {cliente.cpf_cnpj && (
              <div>
                <p className="text-sm text-muted-foreground">CPF/CNPJ</p>
                <p className="font-medium">{cliente.cpf_cnpj}</p>
              </div>
            )}

            {cliente.telefone && (
              <div>
                <p className="text-sm text-muted-foreground">Telefone</p>
                <p className="font-medium">{cliente.telefone}</p>
              </div>
            )}

            {cliente.email && (
              <div>
                <p className="text-sm text-muted-foreground">Email</p>
                <p className="font-medium">{cliente.email}</p>
              </div>
            )}

            {cliente.data_nascimento && (
              <div>
                <p className="text-sm text-muted-foreground">Data de Nascimento</p>
                <p className="font-medium">
                  {format(new Date(cliente.data_nascimento), "dd/MM/yyyy")}
                </p>
              </div>
            )}

            {cliente.endereco && (
              <div className="col-span-2">
                <p className="text-sm text-muted-foreground">Endereço</p>
                <p className="font-medium">{cliente.endereco}</p>
              </div>
            )}

            {cliente.observacoes && (
              <div className="col-span-2">
                <p className="text-sm text-muted-foreground">Observações</p>
                <p className="font-medium">{cliente.observacoes}</p>
              </div>
            )}

            <div>
              <p className="text-sm text-muted-foreground">Data de Criação</p>
              <p className="font-medium">
                {format(new Date(cliente.created_at), "dd/MM/yyyy HH:mm")}
              </p>
            </div>

            <div>
              <p className="text-sm text-muted-foreground">Última Atualização</p>
              <p className="font-medium">
                {format(new Date(cliente.updated_at), "dd/MM/yyyy HH:mm")}
              </p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
